<template>
	<div id="circuitBreakerAging" >
		
		<div class="bottom">
			<!-- <div class="title">负载实时电流</div> -->
			<div class="diagram-2 " style="justify-content: space-between">
				<div class="diagram-content">
					
					<div class="line">
						<span :style="{width:maxdata.widthval+'%'}" :class="maxdata.widthval>40?'red':''"  class="role"></span>
						<div class="tit">
							<span>断路器额定电流</span>
							<span class="realTimeData" v-if="getQuery('额定电流')">{{getQuery('额定电流')}}</span>
							<span class="realTimeData grey" v-else>--</span>
						</div>
					</div>
					<div class="tips"><img src="@/assets/img/tips.png">安全电流警戒线</div>
				</div>

				<div class="land">
					<span>实时电流</span>
					<span class="realTimeData grey" v-if="maxdata.max=='--'">--</span>
					<span class="realTimeData" v-else :style="maxdata.widthval>40?'color:red':''">{{maxdata.max}} A</span>
				</div>
			</div>
		</div>
		<div class="top">
			<p>触头磨损状态</p>
			<div class="status" style="justify-content: flex-start">
				<div class="diagram">
					<Percentage :number="num"></Percentage>
				</div>

				<div class="status-text  column-center" v-if="num<60">
					<div class="row-center"  style="align-items: flex-start;width: 100%;">
						<img src="@/assets/img/success2.png" alt="">
						<span>断路器触头状况良好</span>
					</div>
				</div>
				<div class="status-text status-red column-center" v-else-if="num>=60">
					<div class="row-center" style="align-items: flex-start;width: 100%;">
						<!-- <img src="@/assets/img/error.png" alt=""> -->
						<span style="max-width:100%">断路器触头磨损严重，请及时更换断路器触头</span>
					</div>
				</div>
				<div class="status-text status-gray column-center" v-else-if="num=='--'">
					<div class="row-center" style="align-items: flex-start;width: 100%;">
						<!-- <img src="@/assets/img/error.png" alt=""> -->
						<span>断路器触头状况未知</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Percentage from "./Percentage";

	export default {
		name: "CircuitBreakerAging",
		components: {
			Percentage,
		},
		props:{
			currentLoop:Object,
			currInfo:Object,
			data:String
		},
		data(){
			return{
				num:0,
				list:["Ia","Ib","Ic"],
				max:"",
				widthval:0
			}
		},
		watch:{
			currentLoop(){
				this.widthval = 0
				this.num = this.data
			},
		},
		 computed: {
			getQuery(){
				return function(name){
					let data = this.currInfo.device_details
					for (let arr in data) {
						for (const [key, value] of Object.entries(data[arr])) {
							if(key==name){
								return value
							}
							// console.log(`${key}: ${value}`);
						}
					}
				}
				
			},
            mqttval() {
                return this.getMqttVal(this.$store.getters.mqttVal)
            },
			 maxdata(){
				 let arr = []
				this.list.forEach(element => {
					arr.push(this.mqttval(element))
				});
				arr.sort(function (a, b) {return a-b;});
				if(arr[arr.length - 1]!="--"){
					this.max = Number(arr[arr.length - 1]).toFixed(2);
					if(this.getQuery('额定电流')){
						this.widthval = (Number(this.max)/Number(this.getQuery('额定电流').split('A')[0]))*100
					}else{
						this.widthval = 0
					}
				}else{
					this.max = '--'
					this.widthval = 0
				}
				return {max:this.max,widthval:this.widthval}
			 }
		 },
		 mounted(){
			this.num = this.data
			console.log(this.currentLoop,"currentLoop")
		 },
		 methods: {
			getMqttVal(f) {
                return (k, m) => {
                    if (this.currentLoop && k) {
                        k = this.currentLoop.subLoopUrl + "/" + k;
                        let mqttVal = f(k); 
                        if (m) {
                            mqttVal *= m;
                        }
						// if(k=='Contact_wear'){
						// 	mqttVal = mqttVal;
						// }else{
						// 	mqttVal = floatFormat(mqttVal, 2);
						// }
                        

                        if (typeof mqttVal === "object") {
                            return mqttVal;
                        }
                        return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
                    } else {
                        return "--";
                    }
                };
            },
		 }
	}
</script>

<style scoped lang="less">
	
	.bottom {
		/*padding: 23rem 51rem 48rem 24rem;*/
		background-color: #fff;
		padding-top: 24rem;
		// .h(200);
		width: 100%;
		margin-top: 10rem;
		.title {

			font-size: 18rem;
			font-weight: bold;
			color: #333333;
		}

		.diagram-2 {
			width:100%;
			// .h(131);
			margin-top: 20rem;
			position: relative;
			.land{
				position: relative;
				z-index: 225;
				color: #333;
				font-size: 24rem;
				line-height: 50rem;
				// margin-left: 20rem;
				.realTimeData{
					font-weight: bold;
					font-size: 30rem;
					margin-left: 10rem;
					color: #0D94FF;
				}
			}
			.tips {
				position: absolute;
				bottom: 0;
				left: 40%;
				font-size: 16rem;
				font-weight: 400;
				color: #FF9D4D;
				height: 100rem;
				// border-left: 2px dashed #FF9D4D;
				// padding-left: 7rem;
				// line-height: 76px;
				overflow: hidden;
				&::before{
					content: "";
					border-left: 2px dashed #FF9D4D;
					height: 100%;
					display: inline-block;
					position: absolute;
					top: 25px;
					left: 8px;
				}
				img{
					vertical-align: middle;
					width: 16px;
					margin-right: 5px;
				}
			}

			.diagram-content {
				width: 100%;
				position: relative;
				.line {
					width:100%;
					.h(68);
					// height: 68px;
					border-radius: 8rem;
					background-color: #F0F3F6;
					// opacity: 0.3;
					margin-top: 12rem;
					position: relative;
					overflow: hidden;
					.role{
						position: absolute;
						top: 0;
						left: 0px;
						background: #b0e6ff;
						height: 100%;
						border-radius: 8rem;
					}
					.red{
						background: #FD4238;
					}
				}

				.tit {
					font-size: 18rem;
					font-weight: 400;
					// color: #666666;
					// margin-left: 10px;
					padding:8rem 20rem;
					position: absolute;
					right: 0;
					span{
						display: block;
					}
					.realTimeData {
						// font-size: 24rem;
						// font-weight: bold;
						color: #333333;
						// margin-left: 15rem;
					}
				}
			}
		}
	}
	#circuitBreakerAging {
		width: 100%;
		// .h(910);

		.diagram {
			width: 132rem;
			height: 132rem;
		}

		.top {
			/*padding: 23rem;*/
			margin-top: 10rem;
			width: 100%;
			// .h(212);
			// padding-top: 55rem;
			background: #F5F7F9;
			padding: 10rem 20rem 0rem 20rem;
			box-sizing: border-box;
			// background: #FFFFFF;
			// border-bottom: 1px solid rgba(0, 0, 0, 0.06);

			> p {
				font-size: 18rem;
				font-weight: bold;
				color: #333333;
			}
		}


		.status {
			// margin-top: 85rem;
			display: flex;
			padding: 10rem 0
		}

		.status-text {
			// .w(744);
			// border-bottom: 1px solid rgba(0, 43, 102, 0.15);
			// padding-bottom: 19rem;
			// margin-left: 128rem;
			align-items: flex-start;
			flex:1;
			// .w(200);
			text-align: center;
			img{
				
			}
			span {
				font-size: 24rem;
				font-weight: 400;
				color: #68D86A;
				margin-left: 12rem;
				max-width: 120px;
				text-align: left;
				
			}
		}
		.status-red {
			span{
				color: #FD4238;
			}
		}
		
		.status-gray {
			span{
				color: #666666;
			}
		}
		.status-yellow {
			span{
				color: #F5AA00;
			}
		}
	}
</style>